import React from 'react'
import PropTypes from 'prop-types'

// FPCC
import DictionaryDetailPrimary from 'components/DictionaryDetail/DictionaryDetailPrimary'
import DictionaryDetailSecondary from 'components/DictionaryDetail/DictionaryDetailSecondary'
import DictionaryDetailMedia from 'components/DictionaryDetail/DictionaryDetailMedia'

function DictionaryDetailPresentationDrawer({ entry, sitename }) {
  return (
    <div
      data-testid="DictionaryDetailPresentationDrawer"
      className="max-w-2xl py-6 px-14 space-y-7"
    >
      <DictionaryDetailPrimary entry={entry} />
      <DictionaryDetailSecondary entry={entry} sitename={sitename} />
      <DictionaryDetailMedia entry={entry} />
    </div>
  )
}
// PROPTYPES
const { object, string } = PropTypes
DictionaryDetailPresentationDrawer.propTypes = {
  entry: object,
  sitename: string,
}

export default DictionaryDetailPresentationDrawer
